export default "__VITE_ASSET__8b780d6c__"